module.exports = __webpack_public_path__ + "static/media/arrival_station_icon.f1044d21.svg";